import { Link } from 'react-router-dom';
import { NeighborhoodSummary } from '../models/EventModel';
import styles from './NeighborhoodCard.module.css';

interface NeighborhoodCardProps {
    citySlug: string;
    neighborhood: NeighborhoodSummary;
    className?: string;
}

export default function NeighborhoodCard({ citySlug, neighborhood, className = '' }: NeighborhoodCardProps) {
    const eventCount = neighborhood.eventCountThisWeek;

    return <Link
        to={`/${encodeURIComponent(citySlug)}/${encodeURIComponent(neighborhood.slug)}`}
        className={`${styles.card} ${!neighborhood.imageUrl ? styles.cardWithoutImage : ''} ${className}`}
    >
        {neighborhood.imageUrl && <img src={neighborhood.imageUrl} alt="" className={styles.image} loading="lazy" />}
        <span className={styles.overlay} aria-hidden="true" />
        <span className={styles.cardContent}>
            <strong>{neighborhood.name}</strong>
            <span className={styles.discover}>
                {eventCount == null
                    ? 'Découvrir le quartier'
                    : eventCount === 0
                        ? 'Aucun événement cette semaine'
                        : <><span className={styles.eventCount}>{eventCount}</span> événement{eventCount > 1 ? 's' : ''} cette semaine</>}
                {' '}<span aria-hidden="true">→</span>
            </span>
        </span>
    </Link>;
}
